import { render } from "./OrderStatusSelectorComponent.vue?vue&type=template&id=07b38b99&ts=true"
import script from "./OrderStatusSelectorComponent.vue?vue&type=script&lang=ts"
export * from "./OrderStatusSelectorComponent.vue?vue&type=script&lang=ts"

import "./OrderStatusSelectorComponent.vue?vue&type=style&index=0&id=07b38b99&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__